module.exports = __webpack_public_path__ + "img/20190828162742014.38675772.jpg";